export default __webpack_public_path__ + "static/media/Nitroxgallery_90.5c6fe744.webp";